// SINGLE source of truth for shape decoding + id normalization
import api from '@/services/apiClient';

export type Client = {
  id: string;
  _id?: string;
  clientId?: string;
  name?: string;
  email?: string;
  phone?: string;
  // ...rest
};

export const normalizeClient = (c: any): Client => {
  const id = String(c?._id ?? c?.id ?? c?.clientId ?? '');
  return id ? { ...c, id, _id: id } : c;
};

// List: accepts {data:{items,total}} | {results} | {clients} | []
export async function listClients(params: any = {}) {
  const res = await api.get('/api/clients', { params });
  console.log('🔍 listClients RAW response:', res);

  const body = res?.data ?? {};
  console.log('📦 body:', body);

  const data = body?.data ?? body;
  console.log('📊 data:', data);

  const raw = Array.isArray(data)
    ? data
    : Array.isArray(data?.items)
      ? data.items
      : Array.isArray(data?.results)
        ? data.results
        : Array.isArray(body?.clients)
          ? body.clients
          : [];
  console.log('📝 raw array:', raw);
  console.log('🔢 raw length:', raw.length);

  const items = raw.map(normalizeClient);
  console.log('✅ normalized items:', items);
  console.log('🔢 normalized length:', items.length);
  console.log('🎯 first item:', items[0]);

  const total = Number.isFinite(data?.total) ? data.total : items.length;
  return { items, total };
}

// Create: return the created client normalized
export async function createClient(payload: any): Promise<Client> {
  const res = await api.post('/api/clients', payload);
  const body = res?.data ?? {};
  return normalizeClient(body?.data ?? body?.client ?? body);
}

// Legacy export for backward compatibility
export const createClientApi = createClient;
export type CreateClientInput = any;

// Search function for backward compatibility
export async function searchClients(query: string, limit: number = 10) {
  const q = (query || '').trim();
  if (!q) return [];
  // Use dedicated search endpoint for accurate matching
  const res = await api.get(`/api/clients/search`, { params: { q, limit } });
  const d: any = res?.data ?? res;
  const items = d?.data ?? d?.items ?? [];
  return Array.isArray(items) ? items : [];
}

// Delete client with dependency checking
export async function deleteClient(clientId: string, reason?: string, force: boolean = false) {
  try {
    const res = await api.delete(`/api/clients/${clientId}`, {
      data: { reason, force },
    });
    return res?.data || res;
  } catch (error: any) {
    // Re-throw with structured error
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  }
}
